import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';

interface ScheduleSlotButtonProps {
  start: string;
  selected: boolean;
  busy: boolean;
  className?: string;
  dataTestId?: string;
  onClick: () => void;
}

export function ScheduleSlotButton({
  start,
  selected,
  busy,
  className,
  dataTestId = DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_SLOT_BUTTON,
  onClick,
}: ScheduleSlotButtonProps) {
  return (
    <Button
      variant={selected ? 'default' : 'secondary'}
      color="primary"
      className={cn('py-1.5 xl:py-2 text-sm xl:text-base', busy && 'opacity-60 cursor-progress', className)}
      aria-label={selected ? `${start} — remover do carrinho` : `${start} — adicionar ao carrinho`}
      aria-disabled={busy}
      aria-busy={busy}
      aria-pressed={selected}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {start}
    </Button>
  );
}
